import { ReactNode } from 'react';

type BorderedTextProps = {
  text: ReactNode;
  icon?: string;
  iconAlt?: string;
  className?: string;
};

function BorderedText({ text, icon, iconAlt = '', className = '' }: BorderedTextProps) {
  return (
    <div className={`bordered-text w-100 mb-0 d-flex align-items-center ${className}`.trim()}>
      {icon && (
        <span className="me-2 d-flex align-items-center">
          <img src={icon} alt={iconAlt} />
        </span>
      )}
      <span>{text}</span>
    </div>
  );
}

export default BorderedText;

